import React, { useMemo } from "react";

import { RawFile } from "@mapmycustomers/shared/types/File";
import { useNonNullableContext } from "@mapmycustomers/shared/util/react";

import LockedFiles from "@app/component/activity/LockedFormFields/LockedFiles";

import EmailContext from "../EmailContext";

interface FileProps {
  required?: boolean;
}

const Files = ({ required }: FileProps) => {
  const { attachedFiles } = useNonNullableContext(EmailContext);

  const files = useMemo(
    () =>
      attachedFiles.reduce<RawFile[]>((result, { file }) => {
        return [...result, ...(file ? [file as RawFile] : [])];
      }, []),
    [attachedFiles]
  );

  return <LockedFiles files={files} required={required} />;
};

export default Files;
